import clueRuleConfig from './clueRuleConfig'
export default clueRuleConfig
